import React from 'react';

import { OneInchToken } from '@api';

import { ArrowLeft } from '@uikit/icons/ArrowLeft';

import { OneInchView } from '@magic-swap/components/pages/MagicSwap/types';
import TokensSelect from '@magic-swap/components/pages/MagicSwap/ui/TokenSelect';

interface MagicSwapTokenSelectViewProps {
  tokens: OneInchToken[];
  setToken: (token: OneInchToken) => void;
  setView: (view: OneInchView) => void;
  title?: string;
  fetchTokenBalance: () => Promise<void>;
}

const MagicSwapTokenSelectView = ({
  tokens,
  setToken,
  setView,
  fetchTokenBalance,
  title = 'Choose a Token',
}: MagicSwapTokenSelectViewProps) => {
  return (
    <div className="w-full flex flex-col">
      <div className="flex gap-1 items-center justify-start mb-6">
        <button className="button button-ghost p-1" onClick={() => setView('main')}>
          <ArrowLeft className="icon-lg" />
        </button>

        <h2 className="text-[28px] font-semibold">{title}</h2>
      </div>

      <div className="flex flex-col">
        <TokensSelect
          fetchTokenBalance={fetchTokenBalance}
          tokens={tokens}
          onTokenSelect={(selectedToken) => {
            setToken(selectedToken);
            setView('main');
          }}
        />
      </div>
    </div>
  );
};

export default MagicSwapTokenSelectView;
